import { render } from "./milestone-form-footer-complete.vue?vue&type=template&id=00a0db2e&scoped=true&ts=true"
import script from "./milestone-form-footer-complete.vue?vue&type=script&lang=ts"
export * from "./milestone-form-footer-complete.vue?vue&type=script&lang=ts"

import "./milestone-form-footer-complete.vue?vue&type=style&index=0&id=00a0db2e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a0db2e"]])

export default __exports__